package kz.dentalcrm.app.screens.diagnosis.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_diagnosis_added
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.DiagnosisRepository
import kz.dentalcrm.app.screens.diagnosis.add.mvi.AddDiagnosisViewEvent
import kz.dentalcrm.app.screens.diagnosis.add.mvi.AddDiagnosisViewSideEffect
import kz.dentalcrm.app.screens.diagnosis.add.mvi.AddDiagnosisViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddDiagnosisViewModel : 
    BaseStateViewModel<AddDiagnosisViewEvent, AddDiagnosisViewState, AddDiagnosisViewSideEffect>() {

    private val diagnosisRepository: DiagnosisRepository by inject()

    private val _isLoading = MutableStateFlow(false)
    val loading: StateFlow<Boolean> = _isLoading

    private fun addDiagnosis(
        name: String
    ) {
        setState {
            copy(
                screenState = AddDiagnosisViewState.ScreenState.Adding
            )
        }
        launch(Dispatchers.Default) {
            when (val result = diagnosisRepository.addDiagnosis(
               name = name
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_diagnosis_added), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = AddDiagnosisViewState.ScreenState.Added
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddDiagnosisViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddDiagnosisViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    override fun setInitialState() = AddDiagnosisViewState()

    override fun handleEvents(event: AddDiagnosisViewEvent) {
        when (event) {
            is AddDiagnosisViewEvent.AddDiagnosis -> {
                addDiagnosis(
                    name = event.naming
                )
            }
        }
    }

    override fun onCleared() {
        setState { AddDiagnosisViewState() }
        _isLoading.value = false
    }
}